export const homeUrl = 'https://www.youtube.com'
export const notificationsUrl = 'https://www.youtube.com/account_notifications'
export const privacyUrl = 'https://www.youtube.com/account_privacy'
export const billingUrl = 'https://www.youtube.com/account_billing'
